import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { cloneDeep } from 'lodash';
import { gitBusinessActivityVehicleTransportation } from '../localeConstants/quote';
export var swapTheValuesOfTheYesAndNoOptions = function swapTheValuesOfTheYesAndNoOptions(item, options) {
  if (!item || !options) {
    return item;
  }

  return options === null || options === void 0 ? void 0 : options.find(function (aItem) {
    return aItem.value !== item.value;
  });
};
/**
 * Updates GIT declaration question info with vehicle transportation specific declarations
 * @param questionInfo - The question info object to update
 * @param businessActivity - The current business activity value
 * @param $t - Translation function
 * @returns Updated question info with vehicle transportation declarations
 */

export var applyVehicleTransportationDeclarations = function applyVehicleTransportationDeclarations(questionInfo, businessActivity, $t) {
  var _questionInfoClone$sp;

  if (!questionInfo) return questionInfo;
  var questionInfoClone = cloneDeep(questionInfo); // Find vehicle transportation section

  var vehicleTransportationIndex = questionInfoClone === null || questionInfoClone === void 0 ? void 0 : (_questionInfoClone$sp = questionInfoClone.spec) === null || _questionInfoClone$sp === void 0 ? void 0 : _questionInfoClone$sp.findIndex(function (item) {
    return item.uniqueId === 'vehicle-transportation';
  });

  if (vehicleTransportationIndex !== -1) {
    if (businessActivity === gitBusinessActivityVehicleTransportation) {
      // Add vehicle transportation specific declarations
      questionInfoClone.spec[vehicleTransportationIndex].list = [{
        hideDot: false,
        text: $t('kit:vehicle_transportation_declaration_list.item_1')
      }, {
        hideDot: false,
        text: $t('kit:vehicle_transportation_declaration_list.item_2')
      }, {
        hideDot: false,
        text: $t('kit:vehicle_transportation_declaration_list.item_3')
      }];
    }
  }

  return questionInfoClone;
};
export var getQuoteQuestionExtraRequestFieldData = function getQuoteQuestionExtraRequestFieldData() {
  return {
    hiscox_operated_from_home_question: 'operatedFromHome',
    hiscox_building_ownership_question: 'buildingOwnership',
    hiscox_design_construction_repair_question_1: 'designConstructionRepair',
    hiscox_design_construction_repair_question_2: 'designConstructionRepairRelated',
    hiscox_subcontract_professional_services_question_1: 'scProfServices',
    hiscox_subcontract_professional_services_question_2: 'scProfServicesRelated',
    hiscox_annual_privacy_matters_training_question: 'privacyTraining',
    hiscox_professional_liability_policy_question: 'haveProfLiabilityInsurance',
    hiscox_professional_liability_retroactive_date_available_question: 'professionalLiabilityRetroactiveDateAvailable',
    hiscox_it_consulting_or_technology_services: 'itConsultingOrTechnologyServices',
    hiscox_tangible_goods_or_products_question: 'tangibleGoodsOrProducts',
    hiscox_products_manufactured_by_others_question: 'productsManufacturedByOthersAndSalesLessThan25',
    hiscox_limited_items_part_of_services_question: 'limitedItemsPartOfServices'
  };
};
export var appendQuoteQuestionExtraRequestFieldData = function appendQuoteQuestionExtraRequestFieldData(declarationQuestion, questionId) {
  var extraData = void 0;
  var requestFieldQuestionMap = getQuoteQuestionExtraRequestFieldData();

  if (requestFieldQuestionMap !== null && requestFieldQuestionMap !== void 0 && requestFieldQuestionMap[questionId]) {
    if (declarationQuestion !== null && declarationQuestion !== void 0 && declarationQuestion[questionId]) {
      extraData = _defineProperty({}, requestFieldQuestionMap[questionId], !!declarationQuestion[questionId].truelyValue);
    }
  }

  return extraData;
};
export var removeAccountancyDeclarations = function removeAccountancyDeclarations(questionInfo, config) {
  if (!questionInfo) {
    return null;
  }

  var newquestionInfo = cloneDeep(questionInfo);
  var filterKeyList = ((config === null || config === void 0 ? void 0 : config.accountancyActivies) || []).map(function (item) {
    return item.value;
  });

  var filterSpecItems = function filterSpecItems(items) {
    if (!Array.isArray(items)) return items;
    return items.filter(function (item) {
      return !filterKeyList.includes(item.key);
    }).map(function (item) {
      if (item.list && Array.isArray(item.list)) {
        return _objectSpread(_objectSpread({}, item), {}, {
          list: filterSpecItems(item.list)
        });
      }

      return item;
    });
  };

  if (newquestionInfo !== null && newquestionInfo !== void 0 && newquestionInfo.spec) {
    newquestionInfo.spec = filterSpecItems(newquestionInfo.spec);
  }

  return newquestionInfo;
};